import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@shadcn-in-nx/ui/select";
import { Plus, X, Search } from "lucide-react";
import { toast } from "sonner";

function TableFilterBar({
    searchDraft,
    searchQuery,
    filterRules,
    columns,
    onSearchDraftChange,
    onSearchSubmit,
    onAddFilter,
    onRemoveFilter,
    onUpdateFilter,
    onApplyFilters,
    onClearFilters,
}) {
    return (
        <div className="space-y-4">
            <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    placeholder="Search across all fields... (Press Enter or click Apply)"
                    value={searchDraft}
                    onChange={(e) => onSearchDraftChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") onSearchSubmit();
                    }}
                    className="pl-9"
                />
            </div>

            <div className="bg-card border border-border rounded-lg p-4 shadow-sm">
                <div className="flex flex-col gap-3">
                    {filterRules.map((filter) => (
                        <div key={filter.id} className="flex items-center gap-2">
                            <Select
                                value={filter.field}
                                onValueChange={(v) => onUpdateFilter(filter.id, "field", v)}
                            >
                                <SelectTrigger className="w-[180px]">
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    {columns.map((col) => (
                                        <SelectItem key={col.name} value={col.name}>
                                            {col.name}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>

                            <Select
                                value={filter.operator}
                                onValueChange={(v) => onUpdateFilter(filter.id, "operator", v)}
                            >
                                <SelectTrigger className="w-[140px]">
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="equals">equals</SelectItem>
                                    <SelectItem value="contains">contains</SelectItem>
                                    <SelectItem value="starts_with">starts with</SelectItem>
                                    <SelectItem value="ends_with">ends with</SelectItem>
                                </SelectContent>
                            </Select>

                            <Input
                                placeholder="Enter Value"
                                value={filter.value}
                                onChange={(e) => onUpdateFilter(filter.id, "value", e.target.value)}
                                className="flex-1"
                            />

                            <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => onRemoveFilter(filter.id)}
                                className="hover:bg-destructive/10 hover:text-destructive"
                            >
                                <X className="h-4 w-4" />
                            </Button>
                        </div>
                    ))}

                    <div className="flex items-center gap-2">
                        <Button variant="outline" size="sm" onClick={onAddFilter} className="gap-2">
                            <Plus className="h-4 w-4" />
                            Add Filter
                        </Button>
                        <Button size="sm" onClick={onApplyFilters} className="gap-2">
                            <Search className="h-4 w-4" />
                            Apply
                        </Button>
                        {(searchQuery || filterRules.length > 0) && (
                            <Button variant="outline" size="sm" onClick={onClearFilters} className="gap-2">
                                <X className="h-4 w-4" />
                                Clear
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(TableFilterBar);
